const commonListsPlugin = {

    install(Vue, options) {
        let commonListsPlugin = {
            lists: [],
            initiated: false,
            populate(lists) {
                this.lists = lists;
                this.initiated = true;
            },
            getList(name, loading, callback) {


                if (loading) loading(true);

                var listData = this.lists.find(i => i.name == name);

                if (listData != undefined) {

                    if (listData.loaded == true) {
                        //return listData.list;
                        if (callback) callback(listData.list);
                    } else {
                        if (listData['loading'] != true) {
                            listData['loading'] = true;
                            Vue.axios.get(listData.api)
                                .then(response => {
                                    if (response.data.failed == false) {
                                        listData.list = response.data.payload;
                                        listData['loaded'] = true;
                                    } else {
                                        listData.list = [];
                                    }
                                    if (callback) callback(listData.list);
                                })
                                .catch(err => {
                                    if (callback) callback([]);
                                })
                                .then(() => {
                                    if (loading) loading(false);
                                    listData.loading = false;
                                    return listData.list;
                                });

                            return listData.list;
                        }
                    }
                }

                return [];
            }
        };
        Vue.prototype.$commonLists = commonListsPlugin;
    }

}

export default commonListsPlugin;